<template>
  <div class="tabs-selector">
    <Scrolly class="tabs-selector__scrolly">
      <ScrollyViewport class="tabs-selector__scrolly-viewport">
        <slot />
      </ScrollyViewport>
      <ScrollyBar axis="x" />
    </Scrolly>
  </div>
</template>

<script>
  import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';

  export default {
    name: 'TabsSelector',
    components: {
      Scrolly,
      ScrollyViewport,
      ScrollyBar,
    },
  };
</script>
